import React from 'react';

const ElectricCard = ({ 
  children, 
  className = "",
  color = "#00ff41", // Primary green by default
  width = "100%",
  height = "auto"
}) => {
  // Generate unique ID for this instance's filter
  const filterId = React.useId();
  
  return (
    <div className={`electric-card-wrapper ${className}`} style={{ width }}>
      <svg className="electric-svg-filter">
        <defs>
          <filter id={filterId} colorInterpolationFilters="sRGB" x="-20%" y="-20%" width="140%" height="140%">
            {/* Optimized: Single turbulence with fewer octaves for better performance */}
            <feTurbulence type="turbulence" baseFrequency="0.015" numOctaves="3" result="noise" seed="1" />
            <feOffset in="noise" dx="0" dy="0" result="offsetNoise">
              <animate attributeName="dy" values="0; 200; 0" dur="8s" repeatCount="indefinite" calcMode="ease-in-out" />
            </feOffset>
            <feDisplacementMap in="SourceGraphic" in2="offsetNoise" scale="15" xChannelSelector="R" yChannelSelector="B" />
          </filter>
        </defs>
      </svg>

      <div className="electric-card-container" style={{
        '--electric-color': color,
      }}>
        {/* Content renders first - takes up natural space */}
        <div className="electric-content-main">
          {children}
        </div>

        {/* Border effects overlay on top */}
        <div className="electric-border-layer">
          <div className="electric-inner">
            <div className="electric-border-outer">
              <div 
                className="electric-main-card" 
                style={{ filter: `url(#${filterId})` }}
              />
            </div>
            <div className="electric-glow-1" />
          </div>

          <div className="electric-bg-glow" />
        </div>
      </div>
    </div>
  );
};

export default ElectricCard;
